import { Route } from '@angular/router';

import { ForgotPasswordComponent } from './forgot-password.component';

export const forgotPasswordRoute: Route = {
    path: 'passwordDimenticata',
    component: ForgotPasswordComponent,
    data: {
        pageTitle: 'pagetitles.forgotpassword'
    }
};
